import { useMemo } from "react";

import {
  buildLocaleRecord,
  EmailContentType,
  EmailEditorOpenedFrom,
  EmailEntryPoint,
  Emptyable,
  Locales,
  processWaypointTemplate,
  renderWaypointToHtml,
} from "@simplyk/common";
import { TReaderDocument } from "@usewaypoint/email-builder";

import { LinkedFormTemplateVariables } from "../useLinkedFormTemplateVariables";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import eventRecap2TemplateDe from "@/features/EmailBuilder/Templates/eventRecap2_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import eventRecapTemplateDe from "@/features/EmailBuilder/Templates/eventRecap_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import eventUpdateTemplateDe from "@/features/EmailBuilder/Templates/eventUpdate_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import fromScratchTemplateDe from "@/features/EmailBuilder/Templates/fromScratch_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import fundraisingTemplateDe from "@/features/EmailBuilder/Templates/fundraising_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import generalUpdateTemplateDe from "@/features/EmailBuilder/Templates/generalUpdate_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import invitationTemplateDe from "@/features/EmailBuilder/Templates/invitation_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletter2TemplateDe from "@/features/EmailBuilder/Templates/newsletter2_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletter3TemplateDe from "@/features/EmailBuilder/Templates/newsletter3_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletter4TemplateDe from "@/features/EmailBuilder/Templates/newsletter4_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletter5TemplateDe from "@/features/EmailBuilder/Templates/newsletter5_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletter6TemplateDe from "@/features/EmailBuilder/Templates/newsletter6_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletterTemplateDe from "@/features/EmailBuilder/Templates/newsletter_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import progressUpdateTemplateDe from "@/features/EmailBuilder/Templates/progressUpdate_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import reminderTemplateDe from "@/features/EmailBuilder/Templates/reminder_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import thankYouTemplateDe from "@/features/EmailBuilder/Templates/thankYou_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import eventRecapV2TemplateDe from "@/features/EmailBuilder/Templates/v2/eventRecap_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import fundraisingV2TemplateDe from "@/features/EmailBuilder/Templates/v2/fundraising_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import invitationV2TemplateDe from "@/features/EmailBuilder/Templates/v2/invitation_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import newsletterV2TemplateDe from "@/features/EmailBuilder/Templates/v2/newsletter_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import reminderV2TemplateDe from "@/features/EmailBuilder/Templates/v2/reminder_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature
import thankYouV2TemplateDe from "@/features/EmailBuilder/Templates/v2/thankYou_de.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import eventRecap2Template from "@/features/EmailBuilder/Templates/eventRecap2_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import eventRecap2TemplateFr from "@/features/EmailBuilder/Templates/eventRecap2_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import emptyTemplate from "@/features/EmailBuilder/Templates/empty.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import eventRecapTemplate from "@/features/EmailBuilder/Templates/eventRecap_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import eventRecapTemplateFr from "@/features/EmailBuilder/Templates/eventRecap_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import eventUpdateTemplate from "@/features/EmailBuilder/Templates/eventUpdate_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import eventUpdateTemplateFr from "@/features/EmailBuilder/Templates/eventUpdate_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import fromScratchTemplate from "@/features/EmailBuilder/Templates/fromScratch_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import fromScratchTemplateFr from "@/features/EmailBuilder/Templates/fromScratch_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import fundraisingTemplate from "@/features/EmailBuilder/Templates/fundraising_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import fundraisingTemplateFr from "@/features/EmailBuilder/Templates/fundraising_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import generalUpdateTemplate from "@/features/EmailBuilder/Templates/generalUpdate_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import generalUpdateTemplateFr from "@/features/EmailBuilder/Templates/generalUpdate_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import invitationTemplate from "@/features/EmailBuilder/Templates/invitation_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import invitationTemplateFr from "@/features/EmailBuilder/Templates/invitation_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter2Template from "@/features/EmailBuilder/Templates/newsletter2_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter2TemplateFr from "@/features/EmailBuilder/Templates/newsletter2_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter3Template from "@/features/EmailBuilder/Templates/newsletter3_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter3TemplateFr from "@/features/EmailBuilder/Templates/newsletter3_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter4Template from "@/features/EmailBuilder/Templates/newsletter4_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter4TemplateFr from "@/features/EmailBuilder/Templates/newsletter4_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter5Template from "@/features/EmailBuilder/Templates/newsletter5_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter5TemplateFr from "@/features/EmailBuilder/Templates/newsletter5_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter6Template from "@/features/EmailBuilder/Templates/newsletter6_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletter6TemplateFr from "@/features/EmailBuilder/Templates/newsletter6_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletterTemplate from "@/features/EmailBuilder/Templates/newsletter_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import newsletterTemplateFr from "@/features/EmailBuilder/Templates/newsletter_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import progressUpdateTemplate from "@/features/EmailBuilder/Templates/progressUpdate_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import progressUpdateTemplateFr from "@/features/EmailBuilder/Templates/progressUpdate_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import reminderTemplate from "@/features/EmailBuilder/Templates/reminder_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import reminderTemplateFr from "@/features/EmailBuilder/Templates/reminder_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import thankYouTemplate from "@/features/EmailBuilder/Templates/thankYou_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import thankYouTemplateFr from "@/features/EmailBuilder/Templates/thankYou_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import eventRecapV2Template from "@/features/EmailBuilder/Templates/v2/eventRecap_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import eventRecapV2TemplateFr from "@/features/EmailBuilder/Templates/v2/eventRecap_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import fundraisingV2Template from "@/features/EmailBuilder/Templates/v2/fundraising_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import fundraisingV2TemplateFr from "@/features/EmailBuilder/Templates/v2/fundraising_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import invitationV2Template from "@/features/EmailBuilder/Templates/v2/invitation_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import invitationV2TemplateFr from "@/features/EmailBuilder/Templates/v2/invitation_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import newsletterV2Template from "@/features/EmailBuilder/Templates/v2/newsletter_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import newsletterV2TemplateFr from "@/features/EmailBuilder/Templates/v2/newsletter_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import reminderV2Template from "@/features/EmailBuilder/Templates/v2/reminder_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import reminderV2TemplateFr from "@/features/EmailBuilder/Templates/v2/reminder_fr.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import thankYouV2Template from "@/features/EmailBuilder/Templates/v2/thankYou_en.json";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- template JSONs live with the EmailBuilder feature, same as the imports above
import thankYouV2TemplateFr from "@/features/EmailBuilder/Templates/v2/thankYou_fr.json";

export type WaypointTemplateKey =
  | "waypointEmpty"
  | "waypointFromScratch"
  | "waypointFundraising"
  | "waypointNewsletter"
  | "waypointNewsletter2"
  | "waypointNewsletter3"
  | "waypointNewsletter4"
  | "waypointNewsletter5"
  | "waypointNewsletter6"
  | "waypointInvitation"
  | "waypointReminder"
  | "waypointThankYou"
  | "waypointEventRecap"
  | "waypointEventRecap2"
  | "waypointProgressUpdate"
  | "waypointEventUpdate"
  | "waypointGeneralUpdate";

// Static template metadata — no i18n, sourced directly from template JSON files
const WAYPOINT_BACKDROP_COLORS: Record<WaypointTemplateKey, string> = {
  waypointEmpty: emptyTemplate.root.data.backdropColor,
  waypointFromScratch: fromScratchTemplate.root.data.backdropColor,
  waypointFundraising: fundraisingTemplate.root.data.backdropColor,
  waypointNewsletter: newsletterTemplate.root.data.backdropColor,
  waypointNewsletter2: newsletter2Template.root.data.backdropColor,
  waypointNewsletter3: newsletter3Template.root.data.backdropColor,
  waypointNewsletter4: newsletter4Template.root.data.backdropColor,
  waypointNewsletter5: newsletter5Template.root.data.backdropColor,
  waypointNewsletter6: newsletter6Template.root.data.backdropColor,
  waypointInvitation: invitationTemplate.root.data.backdropColor,
  waypointReminder: reminderTemplate.root.data.backdropColor,
  waypointThankYou: thankYouTemplate.root.data.backdropColor,
  waypointEventRecap: eventRecapTemplate.root.data.backdropColor,
  waypointEventRecap2: eventRecap2Template.root.data.backdropColor,
  waypointProgressUpdate: progressUpdateTemplate.root.data.backdropColor,
  waypointEventUpdate: eventUpdateTemplate.root.data.backdropColor,
  waypointGeneralUpdate: generalUpdateTemplate.root.data.backdropColor,
};

export const STATIC_TEMPLATES: Record<WaypointTemplateKey, Record<Locales, TReaderDocument>> = {
  waypointEmpty: buildLocaleRecord({
    [Locales.EN]: emptyTemplate as unknown as TReaderDocument,
    [Locales.FR]: emptyTemplate as unknown as TReaderDocument,
    [Locales.ES]: emptyTemplate as unknown as TReaderDocument,
    [Locales.DE]: emptyTemplate as unknown as TReaderDocument,
  }),
  waypointFromScratch: buildLocaleRecord({
    [Locales.EN]: fromScratchTemplate as unknown as TReaderDocument,
    [Locales.FR]: fromScratchTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: fromScratchTemplate as unknown as TReaderDocument,
    [Locales.DE]: fromScratchTemplateDe as unknown as TReaderDocument,
  }),
  waypointFundraising: buildLocaleRecord({
    [Locales.EN]: fundraisingTemplate as unknown as TReaderDocument,
    [Locales.FR]: fundraisingTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: fundraisingTemplate as unknown as TReaderDocument,
    [Locales.DE]: fundraisingTemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter: buildLocaleRecord({
    [Locales.EN]: newsletterTemplate as unknown as TReaderDocument,
    [Locales.FR]: newsletterTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletterTemplate as unknown as TReaderDocument,
    [Locales.DE]: newsletterTemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter2: buildLocaleRecord({
    [Locales.EN]: newsletter2Template as unknown as TReaderDocument,
    [Locales.FR]: newsletter2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletter2Template as unknown as TReaderDocument,
    [Locales.DE]: newsletter2TemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter3: buildLocaleRecord({
    [Locales.EN]: newsletter3Template as unknown as TReaderDocument,
    [Locales.FR]: newsletter3TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletter3Template as unknown as TReaderDocument,
    [Locales.DE]: newsletter3TemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter4: buildLocaleRecord({
    [Locales.EN]: newsletter4Template as unknown as TReaderDocument,
    [Locales.FR]: newsletter4TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletter4Template as unknown as TReaderDocument,
    [Locales.DE]: newsletter4TemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter5: buildLocaleRecord({
    [Locales.EN]: newsletter5Template as unknown as TReaderDocument,
    [Locales.FR]: newsletter5TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletter5Template as unknown as TReaderDocument,
    [Locales.DE]: newsletter5TemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter6: buildLocaleRecord({
    [Locales.EN]: newsletter6Template as unknown as TReaderDocument,
    [Locales.FR]: newsletter6TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletter6Template as unknown as TReaderDocument,
    [Locales.DE]: newsletter6TemplateDe as unknown as TReaderDocument,
  }),
  waypointInvitation: buildLocaleRecord({
    [Locales.EN]: invitationTemplate as unknown as TReaderDocument,
    [Locales.FR]: invitationTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: invitationTemplate as unknown as TReaderDocument,
    [Locales.DE]: invitationTemplateDe as unknown as TReaderDocument,
  }),
  waypointReminder: buildLocaleRecord({
    [Locales.EN]: reminderTemplate as unknown as TReaderDocument,
    [Locales.FR]: reminderTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: reminderTemplate as unknown as TReaderDocument,
    [Locales.DE]: reminderTemplateDe as unknown as TReaderDocument,
  }),
  waypointThankYou: buildLocaleRecord({
    [Locales.EN]: thankYouTemplate as unknown as TReaderDocument,
    [Locales.FR]: thankYouTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: thankYouTemplate as unknown as TReaderDocument,
    [Locales.DE]: thankYouTemplateDe as unknown as TReaderDocument,
  }),
  waypointEventRecap: buildLocaleRecord({
    [Locales.EN]: eventRecapTemplate as unknown as TReaderDocument,
    [Locales.FR]: eventRecapTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: eventRecapTemplate as unknown as TReaderDocument,
    [Locales.DE]: eventRecapTemplateDe as unknown as TReaderDocument,
  }),
  waypointEventRecap2: buildLocaleRecord({
    [Locales.EN]: eventRecap2Template as unknown as TReaderDocument,
    [Locales.FR]: eventRecap2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: eventRecap2Template as unknown as TReaderDocument,
    [Locales.DE]: eventRecap2TemplateDe as unknown as TReaderDocument,
  }),
  waypointProgressUpdate: buildLocaleRecord({
    [Locales.EN]: progressUpdateTemplate as unknown as TReaderDocument,
    [Locales.FR]: progressUpdateTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: progressUpdateTemplate as unknown as TReaderDocument,
    [Locales.DE]: progressUpdateTemplateDe as unknown as TReaderDocument,
  }),
  waypointEventUpdate: buildLocaleRecord({
    [Locales.EN]: eventUpdateTemplate as unknown as TReaderDocument,
    [Locales.FR]: eventUpdateTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: eventUpdateTemplate as unknown as TReaderDocument,
    [Locales.DE]: eventUpdateTemplateDe as unknown as TReaderDocument,
  }),
  waypointGeneralUpdate: buildLocaleRecord({
    [Locales.EN]: generalUpdateTemplate as unknown as TReaderDocument,
    [Locales.FR]: generalUpdateTemplateFr as unknown as TReaderDocument,
    [Locales.ES]: generalUpdateTemplate as unknown as TReaderDocument,
    [Locales.DE]: generalUpdateTemplateDe as unknown as TReaderDocument,
  }),
};

const REBUILT_STATIC_TEMPLATES: Partial<Record<WaypointTemplateKey, Record<Locales, TReaderDocument>>> = {
  waypointFundraising: buildLocaleRecord({
    [Locales.EN]: fundraisingV2Template as unknown as TReaderDocument,
    [Locales.FR]: fundraisingV2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: fundraisingV2Template as unknown as TReaderDocument,
    [Locales.DE]: fundraisingV2TemplateDe as unknown as TReaderDocument,
  }),
  waypointNewsletter: buildLocaleRecord({
    [Locales.EN]: newsletterV2Template as unknown as TReaderDocument,
    [Locales.FR]: newsletterV2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: newsletterV2Template as unknown as TReaderDocument,
    [Locales.DE]: newsletterV2TemplateDe as unknown as TReaderDocument,
  }),
  waypointInvitation: buildLocaleRecord({
    [Locales.EN]: invitationV2Template as unknown as TReaderDocument,
    [Locales.FR]: invitationV2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: invitationV2Template as unknown as TReaderDocument,
    [Locales.DE]: invitationV2TemplateDe as unknown as TReaderDocument,
  }),
  waypointReminder: buildLocaleRecord({
    [Locales.EN]: reminderV2Template as unknown as TReaderDocument,
    [Locales.FR]: reminderV2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: reminderV2Template as unknown as TReaderDocument,
    [Locales.DE]: reminderV2TemplateDe as unknown as TReaderDocument,
  }),
  waypointThankYou: buildLocaleRecord({
    [Locales.EN]: thankYouV2Template as unknown as TReaderDocument,
    [Locales.FR]: thankYouV2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: thankYouV2Template as unknown as TReaderDocument,
    [Locales.DE]: thankYouV2TemplateDe as unknown as TReaderDocument,
  }),
  waypointEventRecap: buildLocaleRecord({
    [Locales.EN]: eventRecapV2Template as unknown as TReaderDocument,
    [Locales.FR]: eventRecapV2TemplateFr as unknown as TReaderDocument,
    [Locales.ES]: eventRecapV2Template as unknown as TReaderDocument,
    [Locales.DE]: eventRecapV2TemplateDe as unknown as TReaderDocument,
  }),
};

const REBUILT_BACKDROP_COLORS: Partial<Record<WaypointTemplateKey, string>> = {
  waypointFundraising: fundraisingV2Template.root.data.backdropColor,
  waypointNewsletter: newsletterV2Template.root.data.backdropColor,
  waypointInvitation: invitationV2Template.root.data.backdropColor,
  waypointReminder: reminderV2Template.root.data.backdropColor,
  waypointThankYou: thankYouV2Template.root.data.backdropColor,
  waypointEventRecap: eventRecapV2Template.root.data.backdropColor,
};

export const getWaypointTemplateDocument = (
  templateKey: WaypointTemplateKey,
  locale: Locales,
  isCampaignContext: boolean
): TReaderDocument =>
  (isCampaignContext ? REBUILT_STATIC_TEMPLATES[templateKey]?.[locale] : undefined) ??
  STATIC_TEMPLATES[templateKey][locale];

export const getWaypointTemplateBackdropColor = (
  templateKey: WaypointTemplateKey,
  isCampaignContext: boolean
): string =>
  (isCampaignContext ? REBUILT_BACKDROP_COLORS[templateKey] : undefined) ?? WAYPOINT_BACKDROP_COLORS[templateKey];

export const SYSTEM_EMAIL_TEMPLATE_SLUGS: Record<WaypointTemplateKey, string> = {
  waypointEmpty: "empty",
  waypointFromScratch: "from_scratch",
  waypointFundraising: "fundraising",
  waypointNewsletter: "newsletter",
  waypointNewsletter2: "newsletter_blog",
  waypointNewsletter3: "newsletter_donation_appeal",
  waypointNewsletter4: "newsletter_donor_recognition",
  waypointNewsletter5: "newsletter_multi_column",
  waypointNewsletter6: "newsletter_annual_report",
  waypointInvitation: "invitation",
  waypointReminder: "reminder",
  waypointThankYou: "thank_you",
  waypointEventRecap: "event_recap",
  waypointEventRecap2: "event_recap_next_event",
  waypointProgressUpdate: "progress_update",
  waypointEventUpdate: "event_update",
  waypointGeneralUpdate: "general_update",
};

export const getSystemTemplate = (templateKey: WaypointTemplateKey, isCampaignContext: boolean): string =>
  `${SYSTEM_EMAIL_TEMPLATE_SLUGS[templateKey]}_v${isCampaignContext && REBUILT_STATIC_TEMPLATES[templateKey] ? 2 : 1}`;

// i18n title key for each template — `as const` preserves literal types for the t() call
const WAYPOINT_TITLE_KEY = {
  waypointEmpty: "emailTemplateMenu.suggestedCommunications.startFromScratch.title",
  waypointFromScratch: "emailEditor.templateStep.fromScratch",
  waypointFundraising: "emailEditor.templateStep.fundraising",
  waypointNewsletter: "emailEditor.templateStep.newsletter",
  waypointNewsletter2: "emailEditor.templateStep.newsletter",
  waypointNewsletter3: "emailEditor.templateStep.newsletter",
  waypointNewsletter4: "emailEditor.templateStep.newsletter",
  waypointNewsletter5: "emailEditor.templateStep.newsletter",
  waypointNewsletter6: "emailEditor.templateStep.newsletter",
  waypointInvitation: "emailEditor.templateStep.invitation",
  waypointReminder: "emailEditor.templateStep.reminder",
  waypointThankYou: "emailEditor.templateStep.thankYou",
  waypointEventRecap: "emailEditor.templateStep.eventRecap",
  waypointEventRecap2: "emailEditor.templateStep.eventRecap",
  waypointProgressUpdate: "emailEditor.templateStep.progressUpdate",
  waypointEventUpdate: "emailEditor.templateStep.eventUpdate",
  waypointGeneralUpdate: "emailEditor.templateStep.generalUpdate",
} as const satisfies Record<WaypointTemplateKey, string>;

/**
 * Hook to convert a single Waypoint JSON template to HTML for preview rendering.
 * Uses statically imported templates to render synchronously (no async loading needed).
 * `isCampaignContext` gates the rebuilt designs: the caller decides, since previews also render
 * from the campaign hub, outside FullScreenEmailEditorProvider.
 */
export const useWaypointTemplate = (
  templateKey: WaypointTemplateKey,
  color?: string | null,
  templateVariables?: LinkedFormTemplateVariables,
  isCampaignContext = true
) => {
  const { locale } = useLocaleContext();
  const { organization } = useCurrentUserContext();

  const { html, hasError } = useMemo(() => {
    try {
      const templateDocument = getWaypointTemplateDocument(templateKey, locale, isCampaignContext);
      const processedTemplate = processWaypointTemplate({
        template: templateDocument,
        organization: organization ?? undefined,
        color,
        ...templateVariables,
        locale,
      });
      const renderedHtml = renderWaypointToHtml(processedTemplate);
      return { html: renderedHtml, hasError: false };
    } catch {
      return { html: null, hasError: true };
    }
  }, [templateKey, locale, organization, color, isCampaignContext, templateVariables]);

  return {
    html,
    hasError,
    color,
    backdropColor: getWaypointTemplateBackdropColor(templateKey, isCampaignContext),
  };
};

export type WaypointTemplateConfig = {
  key: WaypointTemplateKey;
  title: string;
  backdropColor: string;
  isRecommended: boolean;
};

// Templates grouped by category — defines which variants belong together and their relative order
const TEMPLATE_GROUPS: Record<string, WaypointTemplateKey[]> = {
  invitation: ["waypointInvitation"],
  fundraising: ["waypointFundraising"],
  newsletter: [
    "waypointNewsletter",
    "waypointNewsletter2",
    "waypointNewsletter3",
    "waypointNewsletter4",
    "waypointNewsletter5",
    "waypointNewsletter6",
  ],
  thankYou: ["waypointThankYou"],
  reminder: ["waypointReminder"],
  eventRecap: ["waypointEventRecap", "waypointEventRecap2"],
};

const GROUP_ORDER = ["invitation", "fundraising", "newsletter", "thankYou", "reminder", "eventRecap"];

const EMAIL_TYPE_TO_LEADING_TEMPLATE: Partial<Record<EmailContentType, WaypointTemplateKey>> = {
  [EmailContentType.INVITATION]: "waypointInvitation",
  [EmailContentType.FOLLOW_UP]: "waypointEventRecap",
  [EmailContentType.REMINDER]: "waypointReminder",
  [EmailContentType.POST_EVENT]: "waypointThankYou",
};

const getNonCampaignLeadingTemplate = (
  emailType: Emptyable<EmailContentType>,
  entryPoint: Emptyable<EmailEntryPoint>,
  legacyOpenedFrom: Emptyable<EmailEditorOpenedFrom>
): WaypointTemplateKey | undefined => {
  if (emailType && EMAIL_TYPE_TO_LEADING_TEMPLATE[emailType]) {
    return EMAIL_TYPE_TO_LEADING_TEMPLATE[emailType];
  }
  const isCrossSell =
    entryPoint === EmailEntryPoint.CrossSellNewsletterPrompt || legacyOpenedFrom === EmailEditorOpenedFrom.CrossSell;
  return isCrossSell ? "waypointNewsletter" : undefined;
};

/**
 * Returns the ordered list of waypoint templates with their metadata.
 * Every key in `recommendedTemplateKeys` (in the order the caller supplies) comes first and is flagged
 * `isRecommended`, followed by every other template in GROUP_ORDER. The remaining `leadTemplateKeys` —
 * suggestions the caller resolved that GROUP_ORDER doesn't list — close the gallery rather than drop out
 * of it. See helpers/useWaypointTemplateSuggestions for how the caller resolves both lists — this hook
 * stays a pure formatting/ordering step so it's readable on its own.
 */
export const useWaypointTemplates = ({
  leadTemplateKeys,
  recommendedTemplateKeys,
  isCampaignContext,
  emailType,
  entryPoint,
  legacyOpenedFrom,
}: {
  leadTemplateKeys: WaypointTemplateKey[];
  recommendedTemplateKeys: WaypointTemplateKey[];
  isCampaignContext: boolean;
  emailType: Emptyable<EmailContentType>;
  entryPoint: Emptyable<EmailEntryPoint>;
  legacyOpenedFrom: Emptyable<EmailEditorOpenedFrom>;
}): WaypointTemplateConfig[] => {
  const { t } = useTranslate();

  return useMemo<WaypointTemplateConfig[]>(() => {
    const defaultOrderedKeys = GROUP_ORDER.flatMap((group) => TEMPLATE_GROUPS[group]);
    const defaultKeys = new Set(defaultOrderedKeys);
    const recommendedKeys = new Set(recommendedTemplateKeys);

    const leadingTemplate = isCampaignContext
      ? undefined
      : getNonCampaignLeadingTemplate(emailType, entryPoint, legacyOpenedFrom);
    const leadingGroupKeys = leadingTemplate
      ? (Object.values(TEMPLATE_GROUPS).find((group) => group.includes(leadingTemplate)) ?? [])
      : [];
    const leadingKeys = new Set(leadingGroupKeys);

    const orderedKeys = [
      ...recommendedTemplateKeys,
      ...leadingGroupKeys.filter((key) => !recommendedKeys.has(key)),
      ...defaultOrderedKeys.filter((key) => !recommendedKeys.has(key) && !leadingKeys.has(key)),
      ...leadTemplateKeys.filter((key) => !recommendedKeys.has(key) && !leadingKeys.has(key) && !defaultKeys.has(key)),
    ];

    return orderedKeys.map((key) => ({
      key,
      title: t("dashboard", WAYPOINT_TITLE_KEY[key]),
      backdropColor: getWaypointTemplateBackdropColor(key, isCampaignContext),
      isRecommended: recommendedKeys.has(key),
    }));
  }, [leadTemplateKeys, recommendedTemplateKeys, isCampaignContext, emailType, entryPoint, legacyOpenedFrom, t]);
};
